import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import granules from '../assets/images/granules.jpg';
import './Hero.css';

export default function Hero() {
  const { t } = useLanguage();

  return (
    <section id="home" className="hero">
      <div className="container hero__inner">
        <div className="hero__content">
          <span className="hero__eyebrow">{t.hero.eyebrow}</span>
          <h1 className="hero__title">{t.hero.title}</h1>
          <p className="hero__subtitle">{t.hero.subtitle}</p>
          <div className="hero__actions">
            <a href="#products" className="btn btn--primary">
              {t.hero.ctaPrimary}
            </a>
            <a href="#contact" className="btn btn--ghost">
              {t.hero.ctaSecondary}
            </a>
          </div>
          <ul className="hero__badges">
            {t.hero.badges.map((badge) => (
              <li key={badge}>{badge}</li>
            ))}
          </ul>
        </div>
        <div className="hero__media">
          <div className="hero__media-frame">
            <img src={granules} alt="Calcium carbonate filler masterbatch granules" loading="eager" />
          </div>
          <div className="hero__media-tag" dir="ltr">PP-400-R · Filler Masterbatch</div>
        </div>
      </div>
    </section>
  );
}
